import React, { useState, useEffect } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

//Local components
import SetProductDrawer from "../drawers/SetProductDrawer";
import ModalWindow from "../Modal";
import Form from "../basics/Form";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

export default function ProductPreferencesConfiguration({ data, getProduct }) {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for local preferences (to be updated)
  //Initialize with data values if available, otherwise false
  const [preferences, setPreferences] = useState(() => ({
    allowInNewOrders: data?.allowInNewOrders === true || false,
    allowInAssembly: data?.allowInAssembly === true || false,
    nonRequiredQC: data?.nonRequiredQC === true || false,
  }));

  // ==========> Component UseEffects<==========
  //Initialize preferences from product data
  useEffect(() => {
    if (data && data.productId) {
      setPreferences({
        allowInNewOrders: data.allowInNewOrders === true,
        allowInAssembly: data.allowInAssembly === true,
        nonRequiredQC: data.nonRequiredQC === true,
      });
    }
  }, [data]);

  // ==========> Component Functions<==========
  //Function to update all preferences at once
  const updateAllPreferences = async () => {
    setIsLoading(true);
    try {
      const updateData = {
        productId: data.productId,
        allowInNewOrders: preferences.allowInNewOrders,
        allowInAssembly: preferences.allowInAssembly,
        nonRequiredQC: preferences.nonRequiredQC,
      };

      const res = await fetchWithTokenJSONPost(
        "/products/update-product-preferences-for-production",
        updateData
      );
      const jsonResponse = await res.json();

      if (jsonResponse.status === "ok") {
        getProduct();
        setModalText("Se han guardado los cambios.");
      } else {
        setModalText("No se pudo realizar la acción.");
      }
      setModalDescription(jsonResponse.description);
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Error al hacer los cambios, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  //Form configuration for preferences - use data values directly
  const preferencesForm = [
    {
      selection: "checkbox",
      id: "allowInNewOrders",
      initialValue: data?.allowInNewOrders === true,
      xs: 12,
      md: 12,
      label: "Permitir crear órdenes de producción con este producto",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: [],
      style: {},
    },
    {
      selection: "checkbox",
      id: "allowInAssembly",
      initialValue: data?.allowInAssembly === true,
      xs: 12,
      md: 12,
      label:
        "Permitir crear registros en Producción y Ensamblaje con este producto",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: [],
      style: {},
    },
    {
      selection: "checkbox",
      id: "nonRequiredQC",
      initialValue: data?.nonRequiredQC === true,
      xs: 12,
      md: 12,
      label: "No requiere control de calidad",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: [],
      style: {},
    },
  ];

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <SetProductDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          existingProductData={data}
          getData={getProduct}
          isNewProduct={false}
        />
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Preferencias de producción para este producto
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form
            key={`preferences-form-${data?.productId}-${data?.allowInNewOrders}-${data?.allowInAssembly}-${data?.nonRequiredQC}`}
            data={preferencesForm}
            handleStateChange={(formState) => {
              setPreferences({
                allowInNewOrders: formState.allowInNewOrders || false,
                allowInAssembly: formState.allowInAssembly || false,
                nonRequiredQC: formState.nonRequiredQC || false,
              });
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="center" spacing={1}>
            {isLoading ? (
              <CircularProgress size={24} color="secondary" />
            ) : (
              <Button
                variant="contained"
                color="secondary"
                size="small"
                sx={{ color: "white" }}
                onClick={updateAllPreferences}
              >
                Actualizar
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </Card>
  );
}
